import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'type',
      type: 'select',
      label: '类型',
      filterable: true,
      clearable: true,
      placeholder: '请选择所属主体',
      options: [
        {title: '公众号', value: 1},
        {title: '视频号', value: 2},
        {title: '服务号', value: 3},
        {title: '订阅号', value: 4}
      ]
    },
    {
      field: 'name',
      type: 'input',
      label: '名称',
      clearable: true,
      placeholder: '请输入名称'
    },
    {
      field: 'oaAccount',
      type: 'input',
      label: '账号',
      clearable: true,
      placeholder: '请输入账号'
    },
    {
      field: 'certifiedStatus',
      type: 'select',
      label: '认证状态',
      filterable: true,
      clearable: true,
      placeholder: '请选择认证状态',
      options: [
        {title: '未认证', value: 0},
        {title: '已认证', value: 1}
      ]
    },
    {
      field: 'certifiedEnterprise',
      type: 'input',
      label: '认证企业',
      clearable: true,
      placeholder: '请输入认证企业'
    },
    {
      field: 'thirdParty',
      type: 'input',
      label: '第三方',
      clearable: true,
      placeholder: '请输入第三方名称'
    },
    {
      field: 'manager',
      type: 'input',
      label: '管理员',
      clearable: true,
      placeholder: '请输管理员'
    },
    {
      field: 'remark',
      type: 'input',
      label: '备注',
      clearable: true,
      placeholder: '请输入关键词'
    }
  ]
}
